<mat-card class="filter-bar-card">

  <mat-card-content>

    <div class="filter-bar">

      <mat-form-field class="filter-daterange" appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ fixedEndDate() ? 'Start date - MM/DD/YYYY' : 'Date range - MM/DD/YYYY' }}{{maxRangeMonths() ?  ' - max ' + maxRangeMonths() + ' months' : ''}}</mat-label>
        <mat-date-range-input [formGroup]="range" [rangePicker]="picker" [max]="maxDate()">
          <!-- readonly, not disabled: a disabled control drops out of the group's
               valueChanges and the range would never reload. Dates are chosen
               through the calendar or the presets, never typed, so a half range
               can no longer reach the form from any path. Clicking either half
               opens the calendar, so the field is not inert. -->
          <input matStartDate formControlName="start" placeholder="Start" #startEl readonly (click)="picker.open()"/>
          <input matEndDate formControlName="end" placeholder="End" #endEl readonly (click)="picker.open()"/>
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker panelClass="no-future-dates" (opened)="onPickerOpened()">
          <mat-date-range-picker-actions>
            <span class="picker-spacer"></span>
            <button mat-button matDateRangePickerCancel>Cancel</button>
            <button mat-raised-button color="primary" matDateRangePickerApply [disabled]="applyDisabled()">Apply</button>
          </mat-date-range-picker-actions>
        </mat-date-range-picker>
        <!-- @if (maxRangeMonths(); as months) {
          <mat-hint>Max range {{ months }} months</mat-hint>
        } -->
      </mat-form-field>

      <mat-button-toggle-group
        class="date-range-presets"
        hideSingleSelectionIndicator
        aria-label="Date range preset"
        [value]="preset()"
        (change)="applyPreset($event.value)">
        @for (option of presetOptions(); track option.value) {
          <mat-button-toggle [value]="option.value">{{ option.label }}</mat-button-toggle>
        }
      </mat-button-toggle-group>

      @if (!hideDataFilters()) {
        <button
          mat-stroked-button [disabled]="!filters.catalogLoaded()"
          class="additional-filters-btn"
          (click)="openAdditionalFilters()">
          <mat-icon>filter_alt</mat-icon>
          Data Filters
        </button>
      }

    </div>

    @if (!hideDataFilters() && filters.chipGroups().length) {

      <mat-expansion-panel #appliedFiltersExpPanel class="applied-chip-groups-panel" expanded="true">
        <mat-expansion-panel-header class="active-link">
          <mat-panel-title> Applied Filters </mat-panel-title>
          <mat-panel-description>
            <!-- <mat-chip-set>
              @for (group of filters.chipGroups(); track group.title) {
                @for (sub of group.subGroups; track sub.title) {
                  <mat-chip>
                    {{sub.title}}
                  </mat-chip>
                }
              }
            </mat-chip-set> -->

            Click here to {{appliedFiltersExpPanel.expanded == true ? 'hide' : 'show'}}
          </mat-panel-description>
        </mat-expansion-panel-header>
        
        @for (group of filters.chipGroups(); track group.title) {

          <div class="chip-group">

            <span class="chip-group-title">{{ group.title }}</span>

            <div class="chip-subgroup-wrapper">

              @for (sub of group.subGroups; track sub.title) {

                <mat-card class="chip-subgroup">

                  <mat-card-header>
                    <mat-card-subtitle class="chip-subgroup-title">{{ sub.title }}</mat-card-subtitle>
                  </mat-card-header>

                  <mat-card-content>

                    <mat-chip-set [attr.aria-label]="group.title + ' — ' + sub.title + ' filters'">

                      @for (chip of sub.chips; track chip.dimension + ':' + chip.value) {
                        <mat-chip (removed)="filters.remove(chip)">
                          {{ chip.label }}
                          <button matChipRemove [attr.aria-label]="'Remove ' + chip.label">
                            <mat-icon>cancel</mat-icon>
                          </button>
                        </mat-chip>
                      }
                      
                    </mat-chip-set>

                  </mat-card-content>

                </mat-card>

              }

            </div>

          </div>

        }
        
      </mat-expansion-panel>

      <!-- <mat-card class="applied-chip-groups">

        <mat-card-header>
          <mat-card-subtitle class="applied-chip-groups-subtitle">Applied Fitlers</mat-card-subtitle>
        </mat-card-header>

        <mat-card-content>

          @for (group of filters.chipGroups(); track group.title) {

          <div class="chip-group">

            <span class="chip-group-title">{{ group.title }}</span>

            <div class="chip-subgroup-wrapper">

              @for (sub of group.subGroups; track sub.title) {

                <mat-card class="chip-subgroup">

                  <mat-card-header>
                    <mat-card-subtitle class="chip-subgroup-title">{{ sub.title }}</mat-card-subtitle>
                  </mat-card-header>

                  <mat-card-content>

                    <mat-chip-set [attr.aria-label]="group.title + ' — ' + sub.title + ' filters'">

                      @for (chip of sub.chips; track chip.dimension + ':' + chip.value) {
                        <mat-chip (removed)="filters.remove(chip)">
                          {{ chip.label }}
                          <button matChipRemove [attr.aria-label]="'Remove ' + chip.label">
                            <mat-icon>cancel</mat-icon>
                          </button>
                        </mat-chip>
                      }
                      
                    </mat-chip-set>

                  </mat-card-content>

                </mat-card>

              }

            </div>

          </div>

        }

        </mat-card-content>

      </mat-card> -->
    }

    <!-- Page-specific fields (e.g. the VIN lookup's search input) render inside the bar. -->
    <ng-content />

  </mat-card-content>

</mat-card>
